module.exports = __webpack_public_path__ + "static/media/Petilil_gaussian2.9fbf814b.png";